export default {
	name: 'Networks',
	options: {
		schema: 'users',
		table: 'network'
	}
};

